import React, {Component} from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {ToastContainer} from 'react-toastify'

import CUFormModal from './CUFormModal'
import AUTableGenerator from '../auto_updaters/Table'


export default (config) => {

    const AUTable = AUTableGenerator(
        config.read.table,
        config.read.fields.join(' '),
        config.read.uniqueKey,
        config.read.columns,
    )

    return class extends Component{

        state = {
            createOpen: false,
            formConfig: config.create
        }

        toggleCreate = (formData = {}) => {
            const newConfig = ((formData.hasOwnProperty(config.read.uniqueKey)) ? config.update : config.create)
            console.log(newConfig)
            this.setState({
                createOpen: !this.state.createOpen,
                formConfig: {formData, ...newConfig}
            })

        }

        render(){
            return (
                    <div className="d-flex flex-column">
                        <div className="d-flex flex-row justify-content-end align-items-end p-3">
                            {this.props.canCreate &&
                                <Button
                                    size="sm"
                                    color="success"
                                    className="float-right"
                                    onClick={this.toggleCreate}>
                                    <FontAwesomeIcon
                                        color="#fff"
                                        icon="plus"/>{' '}
                                    Add New
                                </Button>
                            }
                        </div>
                        <AUTable onRowClick={(rowInfo) => {
                            if(this.props.canEdit) this.toggleCreate(rowInfo.original)
                        }}></AUTable>
                        <CUFormModal
                            config={this.state.formConfig}
                            isOpen={this.state.createOpen}
                            toggle={this.toggleCreate}
                        />
                        <ToastContainer/>
                    </div>
            )
        }

    }
}


